
import { Component, Vue, Prop } from 'vue-property-decorator';

export interface DialogData {
  isOpen: boolean;
  title: string;
  content: string;
}

@Component({
  components: {}
})
export default class Dialog extends Vue {
  @Prop({ required: true })
  protected dialog!: DialogData;
}
